<template>
    <table class="pure-table-bordered">
        <thead ref="tableThead">
            <tr v-for="(thArr, index) in theadDatas" :key="'tr' + index">
                <th
                    v-for="(item, index) in thArr"
                    :key="item.value + index"
                    :rowspan="item.rowspan || 1"
                    :colspan="item.colspan || 1"
                >
                    {{ item.value }}
                </th>
            </tr>
        </thead>
        <tbody :style="{
            height: height
        }">
            <tr
                v-for="(item, index) in tbodyDatas"
                :key="index"
            >
                <td
                    v-for="key in keysArr"
                    :key="key"
                    :class="{
                        'active': getClass(key)
                    }"
                    @click="getClick(item, key)"
                >
                    <slot :index="key" :value="item[key]"></slot>
                    {{ item[key] }}
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
    export default {
        name: 'TheadTbody',
        data(){
            return {

            }
        },
        props: {
            height: String,
            theadDatas: Array,
            tbodyDatas: Array,
            keysArr: Array,
            otherArr: {
                type: Array,
                default(){
                    return []
                }
            },
        },
        methods: {
            getClick(item, key){
                const obj = this.otherArr.find(item => item.index == key);
                if(obj){
                    obj.click(item);
                }
            },
            getClass(key){
                const obj = this.otherArr.find(item => item.index == key);
                return Boolean(obj)
            }
        },
    }
</script>
<style scoped lang="less">
    .active{
        cursor: pointer;
        &:hover{
            background: #02d9fd;
        }
    }
    tbody::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
        display: none;
    }
    tbody::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background-color: #272525;
        background-image: -webkit-linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent 100%
        );
    }
    tbody::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ededed;
        border-radius: 10px;
    }
    .pure-table-bordered {
        z-index: 2;
        border: 1px solid #02d9fd;
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
        tbody{
            display: block;
            overflow-y: scroll;
        }
        thead, tbody tr{
            display: table;
            width: 100%;
            table-layout: fixed;
        }
        th,
        td {
            border: 1px solid #517FB5;
            &:first-child {
            border-left: none;
            }
            &:last-child {
            border-right: none;
            }
        }
        th {
            font-size: 0.15rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #02d9fd;
            padding: 0.05rem 0;
        }
        td {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            padding: 0.05rem 0.1rem;
            border-bottom: none;
            word-wrap:break-word;
            box-sizing: border-box;
        }
        tr:first-child th {
            border-top: none;
        }
        tr:last-child td{
            border-bottom: 1px solid #517FB5;
        }
    }
</style>
